import { FrcFirmado } from "../../shared/model/frc/frc-firmado.model";
import { Permiso } from "../../shared/model/permisos/permiso.model";
import { Vacacion } from "../../shared/model/vacaciones/vacacion.model";
import { fechaLegible } from "./historial-firmados";

/**
 * El documento de cada solicitud, para quien la gestiona (15/10/2026).
 *
 * Queja de Irving: RH no veía en pantalla el documento de cada solicitud;
 * el líder y quien pidió sí. RH audita, así que lo ve, lo descarga y carga
 * uno nuevo. «RH» son los gestores: quien tiene el menú Seguimiento RH y
 * quien administra el Calendario. Aquí solo van las reglas, para que el
 * Seguimiento RH y el Calendario digan lo mismo; quién puede de verdad lo
 * vuelve a decidir el servidor (VacacionBuss y PermisoBuss,
 * gestionaDocumentos).
 */

/**
 * Hay FRC-019 que bajar: la pidió el colaborador, la firmó al pedir y no
 * está negada ni retirada. La misma regla de tieneFrc en «Mis vacaciones»
 * y la del servidor (exigeVerFrc). Lo capturado en el Calendario no tiene
 * FRC: nadie lo firmó.
 */
export function vacacionConFrc(v: Vacacion): boolean {
  return v.origen === "SOLICITUD" && v.tieneFirma === true && (v.estatus === "PENDIENTE" || v.estatus === "ACTIVO");
}

/** Hay FRC-017 que bajar: firmado al pedir y no negado ni retirado (tieneFrc del calendario de permisos). */
export function permisoConFrc(p: Permiso): boolean {
  return p.tieneFirma === true && (p.estatus === "PENDIENTE" || p.estatus === "AUTORIZADO");
}

/**
 * RH le carga el documento a una vacación viva —esperando o autorizada,
 * pedida o capturada—, firmada en papel o no. Lo negado y lo retirado solo
 * se consulta. Lo propio no: el gestor sube lo suyo como cualquiera, con
 * la regla de siempre (solo si firmó en papel), y eso lo ofrece «Mis
 * vacaciones», no esta columna.
 */
export function rhCargaVacacion(v: Vacacion, miId: number | null | undefined): boolean {
  const viva = v.estatus === "PENDIENTE" || v.estatus === "ACTIVO";
  const conOrigen = v.origen === "SOLICITUD" || v.origen === "CAPTURA";
  return viva && conOrigen && v.idUsuario !== miId;
}

/** Lo mismo para un permiso: esperando o autorizado, y que no sea suyo. */
export function rhCargaPermiso(p: Permiso, miId: number | null | undefined): boolean {
  return (p.estatus === "PENDIENTE" || p.estatus === "AUTORIZADO") && p.idUsuario !== miId;
}

/**
 * La columna «Documento» del CSV: lo que RH vería en la tabla, en texto.
 * Lo subido manda (quién y cuándo, que es lo que se audita); si no hay,
 * si falta subir el papel, si se firmó en digital o si no hay nada.
 * «Falta subirlo» solo aplica a lo vivo (con FRC): un permiso retirado
 * que se firmó en papel queda en «Sin documento», como el «—» de la tabla.
 */
export function textoDocumento(
  conFrc: boolean,
  enPapel: boolean | null | undefined,
  firmado: FrcFirmado | null | undefined,
): string {
  if (firmado?.idFirmado) {
    const cuando = firmado.fecha ? " el " + fechaLegible(firmado.fecha.substring(0, 10)) : "";
    const quien = firmado.usuarioNombre ? " por " + firmado.usuarioNombre : "";
    return "Subido" + cuando + quien;
  }
  if (enPapel && conFrc) {
    return "Firmado en papel, falta subirlo";
  }
  return conFrc ? "Firma digital" : "Sin documento";
}
